import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _QuestionMarkCircle;
import QuestionMarkCircle from '@crehana/compass.icons.outline/QuestionMarkCircle';
import SearchIcon from '@crehana/compass.icons.outline/Search';
import { InputField } from "../../InputField";
import { TooltipWrapper } from "../../TooltipWrapper";
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var sectionClassname = 'tw-gap-2 tw-flex tw-flex-wrap tw-justify-between tw-relative tw-items-center';
export var Container = function Container(_ref) {
  var children = _ref.children,
    actions = _ref.actions,
    className = _ref.className,
    isSmallPadding = _ref.isSmallPadding;
  return /*#__PURE__*/_jsx("div", {
    className: cn(isSmallPadding ? 'tw-pt-1.2 tw-px-1.2' : 'tw-py-2 tw-px-2.4', className),
    children: /*#__PURE__*/_jsxs("div", {
      className: sectionClassname,
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-w-auto tw-gap-1.2 tw-flex-wrap sm:tw-flex-nowrap tw-items-center",
        children: children
      }), /*#__PURE__*/_jsx("div", {
        className: sectionClassname,
        children: actions
      })]
    })
  });
};
export var Title = function Title(_ref2) {
  var title = _ref2.title,
    helpLabel = _ref2.helpLabel;
  if (!title || !Boolean(title)) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-font-subtitle5 dark:tw-text-neutral-light-100",
      children: title
    }), helpLabel && /*#__PURE__*/_jsx(TooltipWrapper, {
      containerClassName: "tw-ml-1 tw-text-center tw-whitespace-pre",
      message: helpLabel,
      position: "top",
      offset: 8,
      children: _QuestionMarkCircle || (_QuestionMarkCircle = /*#__PURE__*/_jsx(QuestionMarkCircle, {
        size: 24,
        className: "tw-text-neutral-dark-800 dark:tw-text-neutral-dark-100"
      }))
    })]
  });
};
var Counter = function Counter(_ref3) {
  var value = _ref3.value;
  if (!value) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "dark:tw-bg-neutral-dark-700 tw-bg-neutral-light-400 tw-font-link1 py-2 tw-px-0.8 tw-rounded-0.4 tw-mr-1",
    children: value
  });
};
var Search = function Search(_ref4) {
  var input = _ref4.input;
  if (!input) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-w-full tw-max-w-[209px]",
    children: /*#__PURE__*/_jsx(InputField, _objectSpread(_objectSpread({
      hideLabel: true,
      leadingIcon: SearchIcon,
      placeholder: input.placeholder
    }, input), {}, {
      label: input.label || '' //TODO: if this has default value, then the type should not be required @nando
      ,
      full: true,
      containerClassName: "tw-max-w-[209px]"
    }))
  });
};
export var Toolbar = function Toolbar(_ref5) {
  var children = _ref5.children,
    className = _ref5.className;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: children
  });
};
Toolbar.Container = Container;
Toolbar.Title = Title;
Toolbar.Counter = Counter;
Toolbar.Search = Search;
export default Toolbar;